@if (investmentData) {
  <div
    class="button-container"
    (click)="openMoneyModal()"
    (keydown.space)="openMoneyModal()"
    (keydown.enter)="openMoneyModal()"
    tabindex="0"
    >
    <div class="header">
      @if (investmentData.dip) {
        <p class="dip-stamp-text">{{ 'global.dipShortcut' | translate }}</p>
      }
      {{ 'money.' +  investmentData.type | translate }}
      &#34;<div class="header--name">{{ investmentData.name }}</div>&#34;
    </div>
  </div>
}